module.exports = __webpack_public_path__ + "static/media/option-grid-logo.725a9e03.svg";